export default __webpack_public_path__ + "static/media/worksheet-not-sent.b3728fd5.png";